import React, { useEffect, useState } from 'react';
import Cookie from 'utils/cookies';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import PopupOverlay from '../PopupOverlay/PopupOverlay';
import AboundSignup from '../Abound/AboundSignup';

const AboundSignUpPopup = ({
  getJssoCrosswalkObj,
  loginUserCallback,
  isWapView,
  logout,
}) => {
  const [showAboundPopup, setShowAboundPopup] = useState(false);
  const moduleName = 'abound_signup';
  const onShowCallback = value => {
    if (
      window &&
      window.TimesApps.PopUpList &&
      window.TimesApps.PopUpList[moduleName]
    ) {
      window.TimesApps.PopUpList[moduleName].callbacks.onShowCallback(value);
    }
  };
  const handleShowPopUp = show => {
    setShowAboundPopup(show);
  };

  const handleClosePopup = () => {
    setShowAboundPopup(false);
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'cross_button',
      category: 'abound',
    });
  };

  const showPopUp = force => {
    setShowAboundPopup(true);
    analyticsWrapper('ga4', {
      event: 'user_shown',
      type: 'abound_number_screen',
      category: 'abound',
    });
    const oneDayInMillis = 86400000;
    if (!force) {
      try {
        onShowCallback(true);
        localStorage.setItem(
          'aboundToShowAfter',
          new Date().getTime() + oneDayInMillis,
        );
      } catch (error) {
        //
      }
    }
  };

  useEffect(() => {
    // document.addEventListener('header-widget-logout', () => {
    //   const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
    //   if (!ssoid) {
    //     showPopUp(true);
    //   }
    // });
    try {
      window.TimesApps.PopUpV2Manager.cmd.push(() => {
        if (
          window.TimesApps.PopUpV2Manager &&
          window.TimesApps.PopUpV2Manager?.register &&
          typeof window.TimesApps.PopUpV2Manager.register === 'function'
        ) {
          window.TimesApps.PopUpV2Manager.register(moduleName, () => {
            const ssoid = Cookie.get('ssoid') || Cookie.get('ssoId');
            let aboundNotToShow = false;
            try {
              const storedTime = localStorage.getItem('aboundToShowAfter');
              if (
                storedTime !== null &&
                Number(new Date().getTime()) > Number(storedTime)
              ) {
                aboundNotToShow = true;
              }
            } catch (error) {
              //
            }
            if (window?.location?.href?.indexOf('/games') === -1) {
              aboundNotToShow = true;
            }
            if (ssoid || aboundNotToShow) {
              onShowCallback(false);
            } else {
              window.TimesGDPR.common.consentModule.gdprCallback(dataObj => {
                if (
                  (dataObj.userCountry === 'US' &&
                    dataObj.userRegion !== 'CA') ||
                  (dataObj.userCountry === 'US' &&
                    dataObj.userRegion === 'CA' &&
                    dataObj.consentGiven)
                ) {
                  showPopUp();
                } else {
                  onShowCallback(false);
                }
              });
            }
          });
        }
      });
    } catch (error) {
      console.log('Error in registering onetap popup');
    }
  }, []);
  return showAboundPopup ? (
    <PopupOverlay
      position={isWapView ? 'bottom' : 'topRight'}
      blackOverlayEnabled={isWapView}
      closeCallback={handleClosePopup}
      show={showAboundPopup}
    >
      <AboundSignup
        jssoCrosswalkObj={getJssoCrosswalkObj}
        loginUserCallback={loginUserCallback}
        handleShowPopUp={handleShowPopUp}
        logout={logout}
      />
    </PopupOverlay>
  ) : null;
};

export default AboundSignUpPopup;
